
  import { Vue, Component, Prop } from "vue-property-decorator";

  import DELETE_MANAGERS_ACCESSED_CONTRACTOR from "@/apollo/managers/DeleteManagersAccessedContractor.gql";

  import BasicEmployeeCard from "@/components/card/BasicEmployeeCard.vue";

  import { NOTIFICATION } from "@/entities/Events";
  import Message from "@/data/notificationsMessages";
  import UiButton from "@/components/button/ui-button.vue";
  import getFullName from "@/helpers/getFullName";

  @Component({
    components: {
      UiButton,
      BasicEmployeeCard,
    },
  })
  export default class ManagerSimpleCard extends Vue {
    @Prop({ type: String, required: true }) readonly relationId!: string;
    @Prop({ type: String, required: true }) readonly firstName!: string;
    @Prop({ type: String, required: true }) readonly lastName!: string;
    @Prop({ type: String, required: true }) readonly managerId!: string;
    @Prop({ type: String, default: undefined }) readonly jobTitle!: string;
    @Prop({ type: String, default: undefined }) readonly location!: string;
    @Prop({ type: String, default: undefined }) readonly avatar?: string;

    removeAccess(): void {
      this.$confirm({
        title: `Remove access to ${getFullName(this.firstName, this.lastName)}`,
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: async (confirm: any) => {
          if (confirm) {
            this.removeManagerAccessToContractor();
          }
        },
      });
    }

    async removeManagerAccessToContractor(): Promise<void> {
      try {
        await this.removeAccessToContractor();

        this.$emit("managerAccessRemoved");
        this.$eventBus.emit(NOTIFICATION, Message.successMessage(`Access was removed`));
      } catch (e) {
        this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
      }
    }

    removeAccessToContractor() {
      return this.$apollo.mutate({
        mutation: DELETE_MANAGERS_ACCESSED_CONTRACTOR,
        variables: {
          id: this.relationId,
        },
      });
    }
  }
